import { render, staticRenderFns } from "./FleetItem.vue?vue&type=template&id=23ffac85&"
import script from "./FleetItem.vue?vue&type=script&lang=js&"
export * from "./FleetItem.vue?vue&type=script&lang=js&"
import style0 from "./FleetItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports